const HIGHLIGHT_STORAGE_KEY = "onboarding_guide_highlight_target_v1";
const HIGHLIGHT_EVENT = "onboarding_guide_highlight_requested";

export type OnboardingHighlightRequest = {
  targetId: string;
  requestedAt: number;
  expiresAt: number;
};

export const requestOnboardingHighlight = (
  targetId: string,
  timeoutMs = 10_000,
) => {
  if (!targetId || typeof window === "undefined") return;
  const requestedAt = Date.now();
  const payload: OnboardingHighlightRequest = {
    targetId,
    requestedAt,
    expiresAt: requestedAt + timeoutMs,
  };
  window.sessionStorage.setItem(HIGHLIGHT_STORAGE_KEY, JSON.stringify(payload));
  window.dispatchEvent(
    new CustomEvent<OnboardingHighlightRequest>(HIGHLIGHT_EVENT, {
      detail: payload,
    }),
  );
};

export const readOnboardingHighlightRequest =
  (): OnboardingHighlightRequest | null => {
    if (typeof window === "undefined") return null;
    const raw = window.sessionStorage.getItem(HIGHLIGHT_STORAGE_KEY);
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw) as Partial<OnboardingHighlightRequest>;
      if (!parsed?.targetId) return null;
      const request: OnboardingHighlightRequest = {
        targetId: String(parsed.targetId),
        requestedAt: Number(parsed.requestedAt || Date.now()),
        expiresAt: Number(parsed.expiresAt || Date.now()),
      };
      if (!Number.isFinite(request.expiresAt) || request.expiresAt < Date.now()) {
        window.sessionStorage.removeItem(HIGHLIGHT_STORAGE_KEY);
        return null;
      }
      return request;
    } catch {
      return null;
    }
  };

export const clearOnboardingHighlightRequest = () => {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(HIGHLIGHT_STORAGE_KEY);
};

export const onboardingHighlightEventName = HIGHLIGHT_EVENT;
